import { AsYouType, getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";
const fallbackNames = {
    UA: "Ukraine",
    CZ: "Czechia",
    PL: "Poland",
    DE: "Germany",
    US: "United States",
    GB: "United Kingdom"
};
export function getCountryOptions(locale = "en") {
    const displayNames = typeof Intl !== "undefined" && "DisplayNames" in Intl
        ? new Intl.DisplayNames([locale], { type: "region" })
        : undefined;
    return getCountries()
        .map((iso2) => ({
        iso2,
        name: displayNames?.of(iso2) ?? fallbackNames[iso2] ?? iso2,
        dialCode: `+${getCountryCallingCode(iso2)}`,
        flag: countryFlag(iso2)
    }))
        .sort((a, b) => a.name.localeCompare(b.name));
}
export function normalizePhone(input, country) {
    const phone = parsePhoneNumberFromString(input, country);
    if (!phone || !phone.isValid()) {
        return {
            e164: "",
            country,
            dialCode: country ? `+${getCountryCallingCode(country)}` : "",
            formatted: input,
            isValid: false
        };
    }
    return {
        e164: phone.number,
        country: phone.country ?? country,
        dialCode: `+${phone.countryCallingCode}`,
        formatted: phone.formatInternational(),
        isValid: true
    };
}
export function formatPhonePartial(input, country) {
    return new AsYouType(country).input(input);
}
export function inferCountryFromInternational(input) {
    const phone = parsePhoneNumberFromString(input);
    return phone?.country;
}
function countryFlag(iso2) {
    return iso2
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}
